export const APP_STORE_URL = 'https://apps.apple.com/es/app/id6757167198';
export const APP_STORE_ID = '6757167198';

export const PLAY_STORE_PACKAGE = 'com.elevatestudio.guideme';
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE}`;
